import React, { Component } from "react";
import { Container } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import './_feeStructure.scss';

import FeeDashBoardSection from './feeDashBoard/feeDashBoardSection';
import FeeTypeSection from './feeType/feeTypeSection';
import FeeSetupSection from './FeeSetup/feeSetupSection';
import StudentPayments from './studentPayments/studentPaymentsSection';
import DateWiseFeeSection from './dateWiseFee/dateWiseFeeSection';
import { FeePageShimmer } from './FeeShimmer';
import { canView } from "../../../utils/modulePermissions";
import { AccessDeniedCard } from "../../../utils/moduleGuard";

// /Fee-Structure/* → "Fee_Structure" (see MODULE_ROUTES in moduleAccessGuard).
// module_key ONLY, never module_name: the sidebar group name is shared by sibling
// modules, and can() grants an action when ANY matched row allows it — matching the
// group would let another module's grant leak in.
//
// This container holds no writes — it only routes between tabs. Each tab child attaches
// its OWN guard (attachModuleGuard binds to the owning instance's setState, and the tabs
// are mounted/unmounted independently), so the Access Denied modal always sits next to
// the action that raises it. This file carries only the is_view gate.
const FEE_STRUCTURE_MODULE = ["Fee_Structure"];



const FETCH_STUDENTS = gql`
  query($institution_id: Int!) {
    getStudents(institution_id: $institution_id) {
      id
      student_name
      contact_no
      branch_id
      class_id
      section_id
      exam_id
    }
  }
`;

const FETCH_PAYMENT_MODES = gql`
  query($id: Int) {
    getPaymentModes(id: $id) {
     id
     payment_mode
    }
  }
`;

const GET_STUDENT_PAYMENTS = gql`
query($institute_id: Int){
  getStudentPaymentDetails(institute_id: $institute_id) {
    roll_no
    student_name
    class_name
    section_name
    branch_name
    exam_name
    exam_id
    section_id
    class_id
    branch_id
    total_amount
    pending_amount
    student_mobile
    paid_amount
    tutionFee
    individualDetails{
      discount
      fee_type_id
      fee_amount
      discount
      total_fee
    }
    term_details {
      no_of_terms
      fee_type_id
      initial_amount
      total_amount
      terms {
        term_no
        term_date
        term_amount
        is_paid
        comments
        payment_mode_id
        paid_date
        payment_id
      }
    }
  }
}
`

const TABS = [
  { key: "feeDashBoard",    label: "Dashboard", icon: "fal fa-chart-bar",  path: "/Fee-Structure/dashboard" },
  { key: "feeType",         label: "Fee Type",  icon: "fal fa-tag",        path: "/Fee-Structure/fee-type"  },
  { key: "FeeSetup",        label: "Fee Setup", icon: "fal fa-rupee-sign", path: "/Fee-Structure/fee-setup" },
  { key: "studentPayments", label: "Payments",  icon: "fal fa-credit-card",path: "/Fee-Structure/payments"  },
];

const PATH_TO_KEY = {
  "/Fee-Structure/dashboard": "feeDashBoard",
  "/Fee-Structure/fee-type":  "feeType",
  "/Fee-Structure/fee-setup": "FeeSetup",
  "/Fee-Structure/payments":  "studentPayments",
  "/Fee-Structure":           "feeDashBoard",
};

class FeeStructureHome extends Component {
  render() {
    // is_view === 0 → no fee data is rendered, and the queries below are skipped so
    // nothing is fetched. This MUST stay above the prop reads that follow: with the
    // queries skipped those props are undefined and `getStudents.loading` would throw.
    if (!canView(FEE_STRUCTURE_MODULE)) {
      return (
        <div className="feeStructure" style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 }}>
          <AccessDeniedCard />
        </div>
      );
    }

    const getStudents = this.props.getStudents;
    const getStudentPaymentDetails = this.props.getStudentPaymentDetails;
    const getPaymentModes = this.props.getPaymentModes;

    const isLoading = getStudents.loading || getStudentPaymentDetails.loading || getPaymentModes.loading;
    const hasError  = getStudents.error || getStudentPaymentDetails.error || getPaymentModes.error;

    if (isLoading) {
      return <FeePageShimmer />;
    }

    if (hasError) {
      return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "60vh" }}>
          <i className="fal fa-exclamation-triangle" style={{ fontSize: 36, color: "#ef4444", marginBottom: 12 }} />
          <h5 style={{ color: "#ef4444" }}>Failed to load fee data</h5>
          <p style={{ color: "#6b7280" }}>{(getStudents.error || getStudentPaymentDetails.error || getPaymentModes.error)?.message}</p>
        </div>
      );
    }

    const pathname = this.props.location.pathname;
    const blockType = PATH_TO_KEY[pathname] || "feeDashBoard";

    return (
      <div className="feeStructure" style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 }}>
        <Container fluid className="px-0">
          <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" }}>

            {/* Modern tab header */}
            <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px", borderRadius: "16px 16px 0 0" }}>
              <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
                {TABS.map((tab) => {
                  const isActive = blockType === tab.key;
                  return (
                    <li className="nav-item" key={tab.key}>
                      <a
                        className={`nav-link ${isActive ? "active" : ""}`}
                        href={tab.path}
                        onClick={(e) => { e.preventDefault(); this.props.history.push(tab.path); }}
                        style={{
                          cursor: "pointer",
                          fontWeight: 700,
                          fontSize: 14,
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          padding: "12px 20px",
                          color: isActive ? "#6366f1" : "#4b5563",
                          background: isActive ? "#fff" : "transparent",
                          borderColor: isActive ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                          borderWidth: "1.5px",
                          borderBottomWidth: isActive ? "2px" : "1.5px",
                          borderRadius: "10px 10px 0 0",
                          transition: "all 0.15s ease",
                          marginBottom: "-1.5px",
                          textDecoration: "none",
                        }}
                      >
                        <i className={tab.icon} />
                        {tab.label}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* Content panel */}
            <div style={{ padding: "28px" }}>
              {blockType === "feeDashBoard" && (
                <FeeDashBoardSection
                  getStudentPaymentDetails={getStudentPaymentDetails.getStudentPaymentDetails}
                  getPaymentModes={getPaymentModes.getPaymentModes}
                />
              )}
              {blockType === "feeType"         && <FeeTypeSection />}
              {blockType === "FeeSetup"        && <FeeSetupSection />}
              {blockType === "studentPayments" && (
                <StudentPayments
                  getStudents={getStudents.getStudents}
                  getStudentPaymentDetails={getStudentPaymentDetails.getStudentPaymentDetails}
                  getPaymentModes={getPaymentModes.getPaymentModes}
                />
              )}
            </div>

          </div>
        </Container>
      </div>
    )
  }
}

export default withRouter(withApollo(compose(
  graphql(GET_STUDENT_PAYMENTS, {
    options: (props) => ({
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
      },
      fetchPolicy: "cache-and-network",
    }),
    skip: () => !canView(FEE_STRUCTURE_MODULE),
    name: "getStudentPaymentDetails",
  }),
  graphql(FETCH_STUDENTS, {
    options: (props) => ({
      variables: {
        institution_id: parseInt(Cookies.get("institutionid")),
      },
      fetchPolicy: "cache-and-network",
    }),
    skip: () => !canView(FEE_STRUCTURE_MODULE),
    name: "getStudents",
  }),
  graphql(FETCH_PAYMENT_MODES, {
    options: (props) => ({
      variables: {
        id: parseInt(0),
      },
      fetchPolicy: "cache-and-network",
    }),
    skip: () => !canView(FEE_STRUCTURE_MODULE),
    name: "getPaymentModes",
  }),
)(FeeStructureHome))    
);